import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { expVal } from '@confluence/feature-experiments';
import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';

import SpaceBase from '../../SpaceBase/index.js';

export const SpaceContributorsRoute = (_match: RouteMatch) => {
	if (!expVal('confluence_space_contributors', 'isEnabled', false)) {
		return <NotFound />;
	}

	return (
		<SpaceBase>
			<div>Space Contributors</div>
		</SpaceBase>
	);
};

SpaceContributorsRoute.NAVIGATION_PARAMS = ({ name, params: { spaceKey } }: RouteMatch) => {
	if (!expVal('confluence_space_contributors', 'isEnabled', false)) {
		return false;
	}

	return {
		Screen: {
			screenEvent: {
				name: 'spaceContributorsScreen',
				id: spaceKey,
			},
			pageState: {
				routeName: name,
				spaceKey,
			},
		},
		MainLayout: {
			navView: CONTAINER_HOME_ID,
			spaceKey,
			disableMinWidth: true,
		},
	};
};
